import { render, staticRenderFns } from "./arrowEdit.vue?vue&type=template&id=5146a9e8&scoped=true&"
import script from "./arrowEdit.vue?vue&type=script&lang=js&"
export * from "./arrowEdit.vue?vue&type=script&lang=js&"
import style0 from "./arrowEdit.vue?vue&type=style&index=0&id=5146a9e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5146a9e8",
  null
  
)

export default component.exports